import React from "react";

export default class Battingteam extends React.Component {
  constructor() {
    super();
    this.state = {
      team: {},
      players: {}
    };
  }
  componentDidMount() {
    this.setState(
      {
        team: this.props.team,
        players: this.props.team.players
      },
      () => {

      }
    );
  }
  componentWillReceiveProps(nextProps) {
    this.setState(
      {
        team: nextProps.team,
        players: nextProps.team.players
      },
      () => {

      }
    );
  }

  render() {
    let player = this.state.players;
    let team = this.state.team;
    return (
<div className="pos_rel">
      <div className="widget_body_column_new " style={{'paddingBottom':'29px'}}>
        <div className="flex_col alignstart">
          <h4 className="blueEboldnew16">{team.name}</h4>
          <h6 className="bluesemi9 mt4">{team.action}</h6>
         
        </div>
        <div className="flex_col aligncenter">
          {Object.keys(player).length > 0 ? Object.keys(player).map((ind, index) => {
            return <h4 key={Math.random()} className={index==0 ? "whitesemi16 required" : "whitesemi16 "}>{player[ind]['name']}</h4>
          }) : ""}

        </div>
        <div className="flex_col alignright">
          {Object.keys(player).length > 0 ? Object.keys(player).map((ind) => {
            return <h4 key={Math.random()} className="blueblacknew16 text_blue ">{player[ind]['score']}</h4>
          }) : ""}

        </div>
     
      </div>
      <h6 className="currnt_bat">*currently batting</h6>
</div>


    );
  }
}
